// import  { useState } from "react";
// // import { useNavigate } from "react-router-dom";

// import password from "./password.css";

// import {
//   SESSION_ID,
//   BASE_URL,
//   DEBUG_LOG_ENABLED,
//   ACCESS_TOKEN,
//   AddPassword,
// } from "../Constant";
// import axios from "axios";
// import swal from "sweetalert";
// import apiHelper from "../report/ApiHelpar/apiHelper";
// export default function ForgotPassword(props) {

//   const [forgotpassword, setForgotPassword] = useState({
//     Password: "",
//   });

//   const [code ,setCode]=useState()

//   const handleChange = (e) => {
//     e.stopPropagation();
//     const value = e.target.value;
//     setForgotPassword({ ...forgotpassword, [e.target.name]: value });
//   };

//   const forgetPassword = async (e) => {
//     e.preventDefault();

//     try {
//       const requestData = {
//         username: "sahil",
//       };

//       const response = await apiHelper("forgetPassword", requestData);

//       if (response.respData.message == "OTP has been sent successfully") {
//         const passCade = response.code;
//         setCode(passCade);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//     const changePassword = async (e) => {
//       e.preventDefault();

//       try {
//         const requestData = {
//           username: "",
//           otp: "",
//           code: code,
//           password: "",
//         };

//         const response = await apiHelper("changePassword", requestData);

//         if (response.respData.message == "OTP has been sent successfully") {
//           const passData = response.code;
//         }
//       } catch (error) {
//         console.log(error);
//       }
//     };

//   return (
//     <div className="align-items-center container  py-5 px-xl-5 mx-auto mt-5 ">
//       <div className="wrapper">
//         <div className="col-lg-9">
//           <div className="d-flex flex-column  align-items-center">
//             <form className="Auth-form ">
//               <div className="Auth-form-content  ">
//                 <h3 className="Auth-form-title">ForgotPassword ?</h3>
//                 <div className="text-center"></div>
//                 <div className="form-group text-center mt-3">
//                   <p>You can reset your password here.</p>
//                 </div>
//                 <div className="form-group mt-3">
//                   <label>Email address</label>
//                   <input
//                     type="email"
//                     name="emailId"
//                     //  value={customer.emailId}
//                     className="form-control mt-1"
//                     placeholder="Email Address"
//                   />
//                 </div>
//                 <div className="d-grid gap-2 mt-3">
//                   {/* <button
//             onClick = {saveForgotPassword}
//             type="Reset Password" className="btn btn-primary " >
//               Reset Password
//             </button> */}
//                   <button
//                     type="button"
//                     class="btn btn-primary"
//                     data-bs-toggle="modal"
//                     data-bs-target="#staticBackdrop"
//                     onClick={() => forgetPassword()}
//                   >
//                     Reset Password
//                   </button>
//                   <div
//                     class="modal fade"
//                     id="staticBackdrop"
//                     data-bs-backdrop="static"
//                     data-bs-keyboard="false"
//                     tabindex="-1"
//                     aria-labelledby="staticBackdropLabel"
//                     aria-hidden="true"
//                   >
//                     <div class="modal-dialog modal-dialog-centered">
//                       <div class="modal-content">
//                         <div class="modal-header bg-primary  ">
//                           <h4
//                             class="modal-title text-white  "
//                             id="staticBackdropLabel"
//                           >
//                             Entet OTP
//                           </h4>
//                           <button
//                             type="button"
//                             class="btn-close  "
//                             data-bs-dismiss="modal"
//                             aria-label="Close"
//                           ></button>
//                         </div>
//                         <div class="d-flex justify-content-center h5">
//                           Please enter tne code we just srnt to
//                         </div>
//                         <div class="d-flex justify-content-center ">
//                           88888888888 to procced
//                         </div>
//                         <div class="d-flex justify-content-center mx-5 pt-5">
//                           {/* <input
//                             type="text"
//                             name="Otp"
//                             //  value={customer.emailId}
//                             className="form-control text-center mx-5"

//                             style={{outline: "none" }}
//                             maxLength="4"
//                             placeholder=" 0      0      0        0 "
//                           /> */}
//                           <div className="divOuter">
//                             <div className="divInner">
//                               <input
//                                 className="partitioned"
//                                 type="text"
//                                 maxlength="4"
//                               />
//                             </div>
//                           </div>
//                         </div>

//                         <div class="d-flex justify-content-center mt-2  pb-5">
//                           <a class="text-decoration-none">Resend OTP</a>
//                         </div>
//                         <div class="modal-footer">
//                           <button
//                             type="button"
//                             class="btn btn-secondary"
//                             data-bs-dismiss="modal"
//                           >
//                             Close
//                           </button>
//                           <button
//                             type="button"
//                             class="btn bg-primary"
//                             onClick={() => {
//                               changePassword();
//                             }}
//                           >
//                             Continue
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import apiHelper from "../report/ApiHelpar/apiHelper";
import "./password.css";

const ForgotPassword = () => {
  // State management
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetCode, setResetCode] = useState(null);
  const [step, setStep] = useState(1); // 1 = email entry, 2 = OTP entry, 3 = new password
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  // Handle email change
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (error) setError("");
  };

  // Handle OTP input
  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length <= 6) {
      setOtp(value);
      if (error) setError("");
    }
  };

  // Handle password change
  const handlePasswordChange = (e) => {
    setNewPassword(e.target.value);
    if (error) setError("");
  };

  // Handle confirm password change
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (error) setError("");
  };

  // Request OTP
  const requestOtp = async (e) => {
    e.preventDefault();

    // Validate email
    if (!email || !email.trim()) {
      setError("Please enter your email address");
      return;
    }

    // Email validation regex
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (!emailRegex.test(email)) {
    //   setError("Please enter a valid email address");
    //   return;
    // }

    setLoading(true);
    setError("");

    try {
      const requestData = {
        username: email,
      };

      const response = await apiHelper("forgetPassword", requestData);

    

      if (response?.respData?.message === "OTP has been sent successfully") {
        // Store the code for verification later
        setResetCode(response?.respData.code);
        setMessage("OTP has been sent to your email address");
        setStep(2); // Move to OTP entry step
      } else {
        setError(
          response?.respData?.message || "Failed to send OTP. Please try again."
        );
      }
    } catch (error) {
      console.error("Error requesting OTP:", error);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Verify OTP and proceed to password reset
  const verifyOtp = async (e) => {
    e.preventDefault();

    if (!otp || otp.length !== 6) {
      setError("Please enter the 4-digit OTP");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // You might have an API to verify OTP before allowing password change
      // For now, we're assuming the OTP is valid and moving to the next step
      setMessage("OTP verified successfully");
      setStep(3); // Move to password reset step
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setError("Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
      setMessage("")
    }
  };

  // Change password
  const changePassword = async (e) => {
    e.preventDefault();

    // Validate passwords
    if (!newPassword) {
      setError("Please enter your new password");
      return;
    }

    // if (newPassword.length < 8) {
    //   setError("Password must be at least 8 characters long");
    //   return;
    // }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const requestData = {
        username: email,
        otp: otp,
        code: resetCode,
        password: newPassword,
      };

      const response = await apiHelper("changePassword", requestData);

 

      if (response?.respData?.message === "Password changed successfully") {
        setMessage("Your password has been reset successfully!");
        // Optionally redirect to login page after a delay
        // setTimeout(() => {
        //   window.location.href = "/login";
        // }, 3000);
      } else {
        setError(
          response?.respData?.message ||
            "Failed to change password. Please try again."
        );
      }
    } catch (error) {
      console.error("Error changing password:", error);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
       setMessage("");
    }
  };

  // Resend OTP
  const resendOtp = async () => {
    setLoading(true);
    setError("");

    try {
      const requestData = {
        username: email,
      };

      const response = await apiHelper("forgetPassword", requestData);



      if (response?.respData?.message === "OTP has been sent successfully") {
        setResetCode(response?.respData.code);
        setMessage("New OTP has been sent to your email address");
      } else {
        setError(
          response?.respData?.message ||
            "Failed to resend OTP. Please try again."
        );
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
       setMessage("");
    }
  };

  return (
    <div className="container py-5" style={{ marginTop: 100 }}>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card shadow-sm border-0">
            <div className="card-body p-4">
              <div className="text-center mb-4">
                <h3 className="fw-bold">Reset Your Password</h3>
                <p className="text-muted">
                  {step === 1 &&
                    "Enter your email to receive a password reset code"}
                  {step === 2 && "Enter the 6-digit code sent to your email"}
                  {step === 3 && "Create a new password for your account"}
                </p>
              </div>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              {message && (
                <div className="alert alert-success" role="alert">
                  {message}
                </div>
              )}

              {/* Step 1: Email Entry */}
              {step === 1 && (
                <form onSubmit={requestOtp}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email Address
                    </label>
                    <input
                      // type="email"
                      className="form-control"
                      id="email"
                      value={email}
                      onChange={handleEmailChange}
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Sending...
                        </>
                      ) : (
                        "Send Reset Code"
                      )}
                    </button>
                  </div>
                </form>
              )}

              {/* Step 2: OTP Entry */}
              {step === 2 && (
                <form onSubmit={verifyOtp}>
                  <div className="mb-4">
                    <label htmlFor="otp" className="form-label">
                      Verification Code
                    </label>
                    <div className="otp-input-container mb-3">
                      <input
                        type="text"
                        className="form-control form-control-lg text-center"
                        id="otp"
                        value={otp}
                        onChange={handleOtpChange}
                        placeholder="Enter 6-digit code"
                        maxLength="6"
                        required
                      />
                    </div>
                    <div className="text-center">
                      <button
                        type="button"
                        className="btn btn-link"
                        onClick={resendOtp}
                        disabled={loading}
                      >
                        Resend Code
                      </button>
                    </div>
                  </div>
                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Verifying...
                        </>
                      ) : (
                        "Verify Code"
                      )}
                    </button>
                  </div>
                  <div className="text-center mt-3">
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => setStep(1)}
                    >
                      Back to Email Entry
                    </button>
                  </div>
                </form>
              )}

              {/* Step 3: New Password */}
              {step === 3 && (
                <form onSubmit={changePassword}>
                  <div className="mb-3">
                    <label htmlFor="newPassword" className="form-label">
                      New Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="newPassword"
                      value={newPassword}
                      onChange={handlePasswordChange}
                      placeholder="Enter new password"
                      required
                    />
                    <small className="form-text text-muted">
                      Password must be at least 8 characters long
                    </small>
                  </div>
                  <div className="mb-4">
                    <label htmlFor="confirmPassword" className="form-label">
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                      placeholder="Confirm new password"
                      required
                    />
                  </div>
                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Updating...
                        </>
                      ) : (
                        "Reset Password"
                      )}
                    </button>
                  </div>
                  <div className="text-center mt-3">
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => setStep(2)}
                    >
                      Back to OTP Entry
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
